import axios from 'axios'

const url = 'https://api.graph.cool/simple/v1/cj4zv3jwjzb3z0175px8forbv'

export default function graphql({ query, variables = {} }) {
  return axios({
    url,
    method: 'post',
    data: {
      query,
      variables,
    },
  }).then(({ data }) => data.data)
}



// WEBPACK FOOTER //
// src/javascripts/utils/graphql.js